import { Injectable } from '@angular/core';
import { StorageConstants } from 'common/constants/app.constant';
import { API_URL } from 'common/constants/url.constants';
import { AppModel } from 'common/models/pagemodels/appModel/app.model';
import { FormDataService } from 'common/services/core_services/form.data.service';
import { HttpService } from 'common/services/core_services/http.service';
import { SystemService } from 'common/services/core_services/system.service';

@Injectable({
    providedIn: 'root',
})
export class AppDataService extends FormDataService<AppModel> {
    constructor(protected httpService: HttpService) {
        super(API_URL.appStateInfo, httpService);
    }

    getDataOfAppState(): Promise<any> {
        return new Promise((resolve, reject) => {
            const paramUrl = this.getAPI_URL();
            this.httpService
                .getData(paramUrl)
                .then((data) => {
                    if (data.error) {
                        reject(data.error);
                    } else {
                        resolve(data.datalist);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    dataModel(): AppModel {
        return new AppModel();
    }
}
